import create from 'zustand';
import createVanilla from 'zustand/vanilla';
import type { GlobalFilter, DateRange } from '@hotjar/global-filters';
import { DATE_UNITS, DATE_RANGE_TYPE } from '@hotjar/global-filters';
import type { SortState } from '../../components/Surveys/SurveyView/SurveyResponsesView/ResponsesList/ResponsesList';
import type { RatingFilterValue } from './Responses/Filters/FilterDataType';
import { RATING_TYPE } from './Responses/Filters/FilterDataType';
import type { FilterData } from './Responses/Filters/FilterData';

const defaultDateFilterValue: DateRange = {
  type: DATE_RANGE_TYPE.RELATIVE,
  unit: DATE_UNITS.MONTHS,
  amount: 3,
};

export const defaultRatingFilter: RatingFilterValue = [
  RATING_TYPE.HATE,
  RATING_TYPE.DISLIKE,
  RATING_TYPE.NEUTRAL,
  RATING_TYPE.LIKE,
  RATING_TYPE.LOVE,
];

export const defaultLocalFilters: FilterData[] = [
  { id: '1', type: 'url', value: undefined },
  { id: '2', type: 'completion', value: undefined },
  { id: '3', type: 'recording', value: undefined },
  { id: '4', type: 'keyword', value: undefined },
  { id: '5', type: 'reaction', value: undefined },
];

export const defaultGlobalFilters: GlobalFilter = {
  filterList: [],
  dateRange: defaultDateFilterValue,
};

export const DEFAULT_SORT_STATE: SortState = { key: 'index', direction: 'desc' };

type SurveyStore = {
  localFilters: FilterData[];
  setLocalFilters: (newFilters: FilterData[]) => void;
  globalFilters: GlobalFilter;
  setGlobalFilters: (newFilters: GlobalFilter) => void;
  resetFilters: () => void;
  sort: SortState;
  setSorting: (newSort: SortState) => void;
};

export const surveyViewStore = createVanilla<SurveyStore>((set) => ({
  localFilters: defaultLocalFilters,
  setLocalFilters: (newFilters: FilterData[]) => set(() => ({ localFilters: newFilters })),
  globalFilters: defaultGlobalFilters,
  setGlobalFilters: (newFilters: GlobalFilter) => set(() => ({ globalFilters: newFilters })),
  resetFilters: () =>
    set(() => ({ globalFilters: defaultGlobalFilters, localFilters: defaultLocalFilters })),
  sort: DEFAULT_SORT_STATE,
  setSorting: (newSort: SortState) => set(() => ({ sort: newSort })),
}));

export const useSurveyViewStore = create(surveyViewStore);
